import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-white menu-state-bg-light-primary fw-bold py-4 fs-6 w-275px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_4 = { class: "symbol symbol-50px me-5" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "symbol-label bg-primary text-inverse-warning fw-bolder fs-1"
}
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = { class: "fw-bolder d-flex align-items-center fs-5" }
const _hoisted_9 = { class: "fw-bold text-muted fs-7" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_11 = { class: "menu-item px-5" }
const _hoisted_12 = { class: "menu-item px-5 my-1" }
const _hoisted_13 = { class: "menu-item px-5 d-none" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_15 = { class: "menu-item px-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.userStore.profile.avatar)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.userStore.profile.avatar,
                alt: "User Avatar"
              }, null, 8, _hoisted_5))
            : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.userStore.profile.firstName[0]) + _toDisplayString(_ctx.userStore.profile.lastName[0]), 1))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.userStore.profile.firstName) + " " + _toDisplayString(_ctx.userStore.profile.lastName), 1),
          _createElementVNode("div", _hoisted_9, [
            _createTextVNode("StageCode: "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.userStore.profile.stageCode), 1)
          ])
        ])
      ])
    ]),
    _hoisted_10,
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.requestAccess && _ctx.requestAccess(...args))),
        class: "menu-link text-white px-5"
      }, "Request Access")
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_router_link, {
        to: {name: 'user-settings-general'},
        class: "menu-link text-white px-5"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Manage Profile ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changePassword && _ctx.changePassword(...args))),
        class: "menu-link text-white px-5"
      }, "Change Password")
    ]),
    _hoisted_14,
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args))),
        class: "menu-link text-white px-5"
      }, "Sign Out")
    ])
  ]))
}